import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import leftBar from '@/components/env-bigData/leftBar';
import ratio from '@/components/env-bigData/ratio';
import warn from '@/components/border/warn';
import IwsVideo from '@comp/VideoPlay/IwsVideo';
import ball from '@/components/env-bigData/ball';
import calendarRange from '@/components/env-bigData/calendarRange';
import pieData from '@/components/env-bigData/pieData';
export default {
  props: [],
  components: {
    calendarRange: calendarRange,
    border: border,
    leftBar: leftBar,
    ratio: ratio,
    warn: warn,
    IwsVideo: IwsVideo,
    ball: ball,
    pieData: pieData
  },
  data: function data() {
    return {
      leftInfo: [{
        name: '监测站点',
        icon: 'global',
        value: '2',
        unit: '个'
      }, {
        name: '常住户数',
        icon: 'flag',
        value: '366',
        unit: '户'
      }, {
        name: '常住人口',
        icon: 'team',
        value: '1111',
        unit: '人'
      }],
      leftBarValue: [75, 69, 17, 6, 3, 18],
      leftBarTitle: ['细微粒物PM2.5', '亚微米颗粒物PM1.0', '臭氧', '一氧化碳', '二氧化硫', '二氧化氮'],
      leftTempList: [{
        title: '温度',
        icon: 'flag',
        unit: '℃',
        value: '14'
      }, {
        title: '湿度',
        icon: 'flag',
        unit: '%',
        value: '71'
      }, {
        title: '气压',
        icon: 'flag',
        value: '75',
        unit: 'Pa'
      }],
      waterWarnList: [],
      videoList: [],
      columns1: [{
        title: '断面名称',
        dataIndex: 'areaName',
        key: 'areaName'
      }, {
        title: '经度',
        dataIndex: 'longitude',
        key: 'longitude'
      }, {
        title: '纬度',
        dataIndex: 'latitude',
        key: 'latitude'
      }, {
        title: '断面类型',
        dataIndex: 'areaType',
        key: 'areaType'
      }],
      dataSource1: [{
        areaName: '傅疃河大古镇断面',
        longitude: '119.437',
        latitude: '35.3535',
        areaType: '出境断面'
      }, {
        areaName: '日照水库',
        longitude: '119.3144',
        latitude: '35.4344',
        areaType: '湖库断面'
      }, {
        areaName: '巨峰河G204竹子河桥',
        longitude: '119.3656',
        latitude: '35.2503',
        areaType: '农业面源污染控制断面'
      }],
      columns2: [{
        title: '养殖场户名称',
        dataIndex: 'farmName',
        key: 'farmName'
      }, {
        title: '详细地址',
        dataIndex: 'farmCoor',
        key: 'farmCoor'
      }, {
        title: '经度',
        dataIndex: 'longitude',
        key: 'longitude'
      }, {
        title: '纬度',
        dataIndex: 'latitude',
        key: 'latitude'
      }, {
        title: '养殖种类',
        dataIndex: 'farmType',
        key: 'farmType'
      }],
      dataSource2: [{
        farmName: '日照万顺禽业有限公司',
        farmCoor: '洛河崖村',
        longitude: '118.9650',
        latitude: '35.3753',
        farmType: '蛋鸡'
      }, {
        farmName: '日照鮮纯生态牧业有限公司',
        farmCoor: '洛河崖村',
        longitude: '119.6409',
        latitude: '35.1435',
        farmType: '奶牛'
      }],
      dataSource3: [{
        farmName: '日照市万宝水产集团总公司',
        farmCoor: '洛河崖村',
        longitude: '119.6590',
        latitude: '35.5771',
        farmType: '海水养殖虾类。蟹类、贝类、鱼类。海参'
      }, {
        farmName: '廠头盐场养预场',
        farmCoor: '洛河崖村',
        longitude: '119.4103',
        latitude: '353131',
        farmType: '中国对虾、南美白对虾。半清舌蟠、杂色蛤、缢蛏'
      }],
      columns4: [{
        title: '农田灌区名称',
        dataIndex: 'farmName',
        key: 'farmName'
      }, {
        title: '经度',
        dataIndex: 'longitude',
        key: 'longitude'
      }, {
        title: '纬度',
        dataIndex: 'latitude',
        key: 'latitude'
      }, {
        title: '灌区规模(万亩）',
        dataIndex: 'farmArea',
        key: 'farmArea'
      }, {
        title: '一年几熟',
        dataIndex: 'year',
        key: 'year'
      }, {
        title: '灌溉季节(月份)',
        dataIndex: 'month',
        key: 'month'
      }, {
        title: '灌溉水类型',
        dataIndex: 'type',
        key: 'type'
      }, {
        title: '主要1',
        dataIndex: 'main1',
        key: 'main1'
      }, {
        title: '主要2',
        dataIndex: 'main2',
        key: 'main2'
      }, {
        title: '主要3',
        dataIndex: 'main3',
        key: 'main3'
      }],
      dataSource4: [{
        farmName: '莒县青峰岭灌区',
        longitude: '118.87119',
        latitude: '35.79587',
        farmArea: '30.5',
        year: '一',
        month: '4/6/7/9/10',
        type: '水库',
        main1: '小麦',
        main2: '玉米',
        main3: '水稻'
      }],
      columns5: [{
        title: '原水体编号',
        dataIndex: 'no',
        key: 'no'
      }, {
        title: '水体类型',
        dataIndex: 'type',
        key: 'type'
      }, {
        title: '水域面积（m2）',
        dataIndex: 'waterArea',
        key: 'waterArea'
      }, {
        title: '黑臭段起点',
        dataIndex: 'startPoint',
        key: 'startPoint'
      }, {
        title: '黑臭段起点坐标',
        dataIndex: 'startLng',
        key: 'startLng'
      }, {
        title: '黑臭段终点',
        dataIndex: 'endPoint',
        key: 'endPoint'
      }, {
        title: '黑臭段终点坐标',
        dataIndex: 'endLng',
        key: 'endLng'
      }, {
        title: '透明度(cm)(均值)',
        dataIndex: 'opacity',
        key: 'opacity'
      }, {
        title: '溶解氧（mg/L）(均值)',
        dataIndex: 'o',
        key: 'o'
      }, {
        title: '氨氮（mg/L）(均值)',
        dataIndex: 'NH',
        key: 'NH'
      }],
      dataSource5: [{
        no: '3711220028',
        type: '坑塘',
        waterArea: '3500',
        startPoint: '洛河崖村',
        startLng: '118.835994,35.714552',
        endPoint: '洛河崖村',
        endLng: '118.83602,35.714325',
        opacity: '32',
        o: '1.5',
        NH: '2.05'
      }]
    };
  },
  mounted: function mounted() {
    this.$refs.leftBar.initBarChart(this.leftBarValue, this.leftBarTitle);
    var time = '2023-03';
    var month = new Date(time).getMonth() + 1; //获取当前月

    var year = new Date(time).getFullYear(); //获取当前年

    var datas = []; //新建日期数组

    var dataLength = new Date(year, month).toJSON().substring(0, 10).split('-')[2]; //获取当前年月日期最大值

    for (var i = 0; i < Number(dataLength); i++) {
      var months = month >= 10 ? month : '0' + month;
      var day = i + 1 >= 10 ? i + 1 : '0' + (i + 1);
      datas.push({
        date: year + '-' + months + '-' + day,
        total: Math.floor(Math.random() * 10) % 10
      }); //存入数组
    }

    this.$refs.calendarRange.initBarChart(time, datas, 9);
    this.$refs.ball.initBarChart(0.9091, '数据上传率');
    this.$refs.pieData.initBarChart([{
      name: '达标',
      value: 18
    }, {
      name: '不达标',
      value: 8
    }]);
    var warnArr = ['黑臭水体溢出', '台风', '陌生人', '危险区域生物闯入'];

    for (var _i = 0; _i < 10; _i++) {
      this.waterWarnList.push({
        siteName: "\u6D1B\u6CB3\u5D16\u6751",
        warnContent: warnArr[_i % 4],
        warnTime: "2023-03-".concat(_i + 10, " 15:04:05")
      });
      this.videoList.push({});
    }

    console.log('waterWarnList', this.waterWarnList.length);
  },
  methods: {
    back: function back() {
      var _this = this;

      clearInterval(this.$refs.ball.timer);
      this.$nextTick(function () {
        _this.$emit('back');
      });
    }
  }
};